var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from "react";
import { unexpectedErrorNotification, validationErrorNotification, } from "../../helpers";
import { NOTIFICATION_LEVEL } from "../../constants";
import { getSdkConversationObject } from "../../conversations-objects";
import { useTranslation } from "react-i18next";
var SettingsMenu = function (props) {
    var t = useTranslation(["chat"]).t;
    var _a = __read(useState(false), 2), isTitleModalOpen = _a[0], setIsTitleModalOpen = _a[1];
    var _b = props.conversation, friendlyName = _b.friendlyName, notificationLevel = _b.notificationLevel;
    var _c = __read(useState(friendlyName), 2), convoNewTitle = _c[0], setConvoNewTitle = _c[1];
    var muted = notificationLevel === NOTIFICATION_LEVEL.MUTED;
    var sdkConvo = useMemo(function () { return getSdkConversationObject(props.conversation); }, [props.conversation.sid]);
    var toggleMuteConversation = function () {
        sdkConvo.setUserNotificationLevel(muted
            ? NOTIFICATION_LEVEL.DEFAULT
            : NOTIFICATION_LEVEL.MUTED);
    };
    var handleTitleModalClose = function () { return setIsTitleModalOpen(false); };
    var handleTitleModalSave = function (title) { return __awaiter(void 0, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (title == "") {
                        validationErrorNotification(props.addNotifications);
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, props.updateConvo(title)];
                case 2:
                    _a.sent();
                    setIsTitleModalOpen(false);
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    unexpectedErrorNotification(props.addNotifications);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs("div", { children: [_jsxs("div", __assign({ className: "btn-group settings-toggle" }, { children: [_jsx("img", { className: "message-read-icon dropdown-toggle dropdown-toggle-split", "data-bs-toggle": "dropdown", "aria-expanded": "false", src: "".concat(process.env.IMG_URL, "/static/vendors/images/icons/dots-vertical.svg"), alt: "read" }), _jsxs("ul", __assign({ className: "dropdown-menu dropdown-menu-end convo-settings-list" }, { children: [_jsxs("button", __assign({ className: "dropdown-item", onClick: function () { return setIsTitleModalOpen(true); } }, { children: [_jsx("img", { className: "pe-2", src: "".concat(process.env.IMG_URL, "/static/vendors/images/icons/pencil-blue.svg"), alt: "update" }), t("Edit conversation name")] })), _jsxs("button", __assign({ className: "dropdown-item", onClick: toggleMuteConversation }, { children: [_jsx("img", { className: "pe-2", src: "".concat(process.env.IMG_URL, "/static/vendors/images/icons/").concat(muted ? "unmute" : "alarme", ".svg"), alt: muted ? "unmute" : "alarm" }), muted ? t("Unmute Conversation") : t("Mute Conversation")] })), _jsxs("button", __assign({ className: "dropdown-item", onClick: props.onParticipantListOpen }, { children: [_jsx("img", { className: "pe-2", src: "".concat(process.env.IMG_URL, "/static/vendors/images/icons/members.svg"), alt: "members" }), t("Manage Participants")] })), _jsx("div", { className: "dropdown-divider" }), _jsx("button", __assign({ className: "dropdown-item text-danger", onClick: props.leaveConvo }, { children: t("Leave conversation") }))] }))] })), _jsx("div", __assign({ className: "modal  ".concat(isTitleModalOpen ? "show" : ""), style: { display: isTitleModalOpen ? "block" : "none" }, tabIndex: -1, role: "dialog" }, { children: _jsx("div", __assign({ className: "modal-dialog modal-fullscreen-md-down modal-dialog-centered", role: "document" }, { children: _jsxs("div", __assign({ className: "modal-content" }, { children: [_jsxs("div", __assign({ className: "modal-header" }, { children: [_jsx("h5", __assign({ className: "modal-title" }, { children: t("Edit conversation name") })), _jsx("img", { onClick: handleTitleModalClose, src: "".concat(process.env.IMG_URL, "/static/vendors/images/icons/close.svg"), alt: "close", className: "close modal-close" })] })), _jsx("div", __assign({ className: "modal-body" }, { children: _jsx("form", { children: _jsx("div", __assign({ className: "form-group" }, { children: _jsxs("div", __assign({ className: "input-wrapper" }, { children: [_jsxs("label", __assign({ htmlFor: "conversation-title", className: "strong" }, { children: [t("Title"), " ", _jsx("span", { children: "*" })] })), _jsx("input", { type: "text", 
                                                    /* @ts-ignore */
                                                    placeholder: t("Title"), id: "conversation-title", defaultValue: friendlyName !== null && friendlyName !== void 0 ? friendlyName : "", onChange: function (e) { return setConvoNewTitle(e.target.value); } })] })) })) }) })), _jsxs("div", __assign({ className: "modal-footer" }, { children: [_jsx("button", __assign({ type: "button", className: "btn btn-secondary compact modal-cancel-button me-1", onClick: handleTitleModalClose }, { children: t("Cancel") })), _jsx("button", __assign({ type: "button", className: "btn btn-primary compact me-1", onClick: function () {
                                            handleTitleModalSave(convoNewTitle || "");
                                        } }, { children: t("Save") }))] }))] })) })) }))] }));
};
export default SettingsMenu;
